import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

export default function Breadcrum({ links }) {
  return (
    <nav className="flex flex-wrap items-center text-xs text-gray-400 gap-1 mb-2">
      {links.map((link, index) => (
        <div key={index} className="flex items-center">
          <Link
            key={index}
            to={link.href}
            className={`${index < links.length - 1 ? "text-aw-green hover:text-aw-green-75" : "text-gray-300"}`}
          >
            {link.label}
          </Link>
          {index < links.length - 1 && <span className="mx-1">›</span>}
        </div>
      ))}
    </nav>
  );
}
